module.exports = "## Crop Photos Using Our Image Editor\r\n\r\nCreate better compositions, remove unwanted parts, or get the aspect ratio right"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-header.md
// module id = 1146
// module chunks = 0